<div class="filter-container">
  @for (d of durations; track d) {
  <av-filter-item [value]="d" (changed)="selectionChanged($event)">
    {{ d }} {{ "minutes" | translate }}
  </av-filter-item>
  }
</div>
